/**
 * API Configuration System
 * Centralized management of multiple API endpoints with pattern-based header rules
 */

export interface ApiEndpoint {
  baseURL: string;
  name: string;
  description?: string;
}

export interface ApiConfig {
  endpoints: Record<string, ApiEndpoint>;
  defaultEndpoint: string;
}

/**
 * Header rule for pattern-based header management
 */
export interface HeaderRule {
  pattern: string | RegExp;
  add?: Record<
    string,
    string | (() => string | null) | (() => Promise<string | null>)
  >;
  remove?: string[];
  set?: Record<
    string,
    string | (() => string | null) | (() => Promise<string | null>)
  >;
  priority?: number;
}

/**
 * Creates an API configuration object
 */
export function createApiConfig(config: ApiConfig): ApiConfig {
  if (!config.endpoints[config.defaultEndpoint]) {
    throw new Error(
      `Default endpoint "${config.defaultEndpoint}" not found in endpoints`,
    );
  }
  return config;
}

/**
 * Creates a header rule with default priority
 */
export function createHeaderRule(rule: HeaderRule): HeaderRule {
  return {
    priority: 0,
    ...rule,
  };
}

/**
 * Helper to create a regex pattern from string
 */
export function pattern(pattern: string | RegExp): string | RegExp {
  if (typeof pattern === "string") {
    return pattern;
  }
  return pattern;
}
